export const EXCMUSERDATASALESOPPORTUNITY_DELETE_RESET = 'EXCMUSERDATASALESOPPORTUNITY_DELETE_RESET'
export const EXCMUSERDATASALESOPPORTUNITY_DELETE_SET_ERROR = 'EXCMUSERDATASALESOPPORTUNITY_DELETE_SET_ERROR'
export const EXCMUSERDATASALESOPPORTUNITY_DELETE_SET_DELETED = 'EXCMUSERDATASALESOPPORTUNITY_DELETE_SET_DELETED'
export const EXCMUSERDATASALESOPPORTUNITY_DELETE_TOGGLE_LOADING = 'EXCMUSERDATASALESOPPORTUNITY_DELETE_TOGGLE_LOADING'
